export default "__VITE_ASSET__BOOeMBbp__"